<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
    <div
      class="d-flex align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">
          2020 &nbsp;&copy;&nbsp;
        </span>
        <a
          href="http://keenthemes.com/metronic"
          target="_blank"
          class="text-dark-75 text-hover-primary"
        >
          蜜蜂代理
        </a>
      </div>
      <div class="nav nav-dark">
        <a
          href="https://www.beesproxy.com/help"
          target="_blank"
          class="nav-link pr-3 pl-0"
        >
          帮助文档
        </a>
        <a
          href="https://work.weixin.qq.com/kfid/kfccef5eea261c9f491"
          target="_blank"
          class="nav-link px-3"
        >
          微信客服
        </a>
        <a
          href="https://www.beesproxy.com"
          target="_blank"
          class="nav-link pl-3 pr-0"
        >
          首页
        </a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  },
};
</script>
